import {lazy} from 'react';

export const BarcodeLazy = lazy(() => import(/* webpackChunkName: "barcode" */ '.'));
